"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiData_1 = __importDefault(require("@/api/class/ApiData"));
const selectApi = {
    dict: new ApiData_1.default({
        name: '通用字典接口',
        url: 'web/common/getDictByCodeList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    cascader: new ApiData_1.default({
        name: '通用级联字典接口',
        url: 'web/common/getDictAndChildren',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    location: new ApiData_1.default({
        name: '省市区',
        url: 'web/common/get/address/list',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    operationRegion: new ApiData_1.default({
        name: '运营大区',
        url: 'web/common/get/operating/area',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    areaRegion: new ApiData_1.default({
        name: '区域列表',
        url: 'web/csAssignRuleArea/list',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    operationPersonnel: new ApiData_1.default({
        name: '运营人员',
        url: 'web/common/get/operating/center/user',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    contractStatus: new ApiData_1.default({
        name: '合同状态',
        url: 'web/cs-overdue-record/getContractStatusDict',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    vehicleStatus: new ApiData_1.default({
        name: '车辆状态',
        url: 'web/cs-overdue-record/getVehicleStatusDict',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    overdueStatus: new ApiData_1.default({
        name: '逾期状态',
        url: 'web/cs-overdue-record/getOverStatusDict',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    })
};
exports.default = selectApi;
